"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordRequestEmailRequestPayloadToJSON = exports.ForgotPasswordRequestEmailRequestPayloadFromJSONTyped = exports.ForgotPasswordRequestEmailRequestPayloadFromJSON = void 0;
function ForgotPasswordRequestEmailRequestPayloadFromJSON(json) {
    return ForgotPasswordRequestEmailRequestPayloadFromJSONTyped(json, false);
}
exports.ForgotPasswordRequestEmailRequestPayloadFromJSON = ForgotPasswordRequestEmailRequestPayloadFromJSON;
function ForgotPasswordRequestEmailRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailAddress': json['emailAddress'],
    };
}
exports.ForgotPasswordRequestEmailRequestPayloadFromJSONTyped = ForgotPasswordRequestEmailRequestPayloadFromJSONTyped;
function ForgotPasswordRequestEmailRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'emailAddress': value.emailAddress,
    };
}
exports.ForgotPasswordRequestEmailRequestPayloadToJSON = ForgotPasswordRequestEmailRequestPayloadToJSON;
//# sourceMappingURL=ForgotPasswordRequestEmailRequestPayload.js.map